
















































import { Component, Prop, Mixins } from 'vue-property-decorator';
import { mapActions } from 'vuex';
import { State } from 'vuex-class';
import { MetaInfo } from 'vue-meta';
import { ModuleCard } from '@/components/parts/modules';
import { ListPageLayout } from '@/uikit';
import { ListLayout, PaginationLayout } from '@/components/parts/listlayout';
import SiteMap from '@/components/layout/SiteMap.vue';
import { Breadcrumbs as BreadcrumbsLayout } from '@/components/layout';
import { Filter as FormFilter } from '@/components/parts/form';
import { Yellow as FilterYellow } from '@/components/parts/filter';
import { Paginator as PaginatorDefault } from '@/components/parts/pagination';
import SelectCount from '@/components/parts/catalog/list/count';
import { Sort as CatalogSort } from '@/components/parts/catalog/list';
import { filterMixin } from './mixins';
import breadcrumbsMixin from '../mixins/breadcrumbs-mixin';
import pageLimitChange from '@/pages/mixin-list';
import mixinNav from '@/pages/mixin-nav';
import createStoreModule from './store';
import { Context } from './types';
import {
  FILTER_MENU,
  DEFAULT_SORT,
  PAGE_SIZE,
  PAGE_NUMBER,
  STORE_MODULE_NAME,
  FETCH_ITEMS,
  LIMITS,
} from './consts';
import isArrayNotEmpty from '@/tools/isarraynotempty';

const actions = mapActions(STORE_MODULE_NAME, [FETCH_ITEMS]);
const fetch = actions[FETCH_ITEMS];

@Component({
  components: {
    ListLayout,
    SiteMap,
    BreadcrumbsLayout,
    SelectCount,
    FormFilter,
    FilterYellow,
    ListPageLayout,
    ModuleCard,
    CatalogSort,
    PaginationLayout,
    PaginatorDefault,
  },
  storeName: STORE_MODULE_NAME,
  storeRegister: createStoreModule,

  inheritAttrs: false,

  metaInfo(): MetaInfo {
    return {
      title: 'Конструктор программ',
    };
  },
})
export default class ModulesList extends Mixins(
  breadcrumbsMixin,
  filterMixin,
  pageLimitChange,
  mixinNav,
) {
  @State(STORE_MODULE_NAME) state: any;

  @Prop({ type: String, default: DEFAULT_SORT })
  readonly sort: string;

  @Prop({ type: [String, Number], default: PAGE_NUMBER })
  readonly page: string | number;

  @Prop({ type: String, default: PAGE_SIZE })
  readonly limit: string;

  public sortNav = FILTER_MENU;

  get modulesList() {
    return this.state.items || [];
  }

  get isContainData() {
    return isArrayNotEmpty(this.modulesList);
  }

  get pageLimits() {
    return LIMITS.map((item) => {
      return {
        text: item,
        value: item,
      };
    });
  }

  get pageLimit() {
    return parseInt(this.limit);
  }

  get pagesCount() {
    return Math.ceil(this.state.count / this.pageLimit);
  }

  beforeDestroy() {
    this.$store.state.nextOpenModuleCard = false;
  }

  get sortList() {
    return this.sortNav.map(({ text, value }) => {
      const to = {
        ...this.$route,
        query: {
          ...this.$route.query,
          sort: value,
        },
      };
      return { text, to, active: this.sort === value };
    });
  }

  get filterProps() {
    const { localFilterFields, localFilterValues } = this;
    const key = JSON.stringify(localFilterValues);
    return {
      key,
      route: 'modules',
      fields: localFilterFields,
      values: localFilterValues,
      hasSwitcher: false,
      title: 'Поиск модулей',
    };
  }

  get localFilterValues() {
    const { filterValues, limit, sort } = this;
    const addedValues = {
      sort,
      limit,
    };
    return {
      ...filterValues,
      ...addedValues,
    };
  }

  get localFilterFields() {
    const addedFields = [
      { type: 'hidden', code: 'sort' },
      { type: 'hidden', code: 'limit' },
    ];
    return [...(this as any).filterFields, ...addedFields];
  }

  asyncData({ store, route }: Context): Promise<any> {
    const context = { $store: store };
    const params = {
      page: PAGE_NUMBER,
      limit: PAGE_SIZE,
      ...route.query,
      ...route.params,
    };
    return fetch.call(context, params);
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/modules/list/ModulesList.vue